import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Layout from './Layout'
import { AuthError, AuthSuccess } from './AuthMessage'
import { getErrorFromLocation } from './utils'

class AuthView extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    extraControl: PropTypes.element,
    outerControl: PropTypes.element,
  }
  render() {
    const { children, auth, error, extraControl, outerControl } = this.props

    return (
      <Layout>
        <div className="content-main flexbox flexbox-column flexbox-align-center">
          {error && <AuthError error={error} />}
          {auth.success &&
            auth.success.message && <AuthSuccess success={auth.success} />}
          <div
            className="background-shade-100 radius-normal padding-largest"
            style={{
              width: '420px',
              boxShadow: '0 2px 40px 0 rgba(0, 0, 0, 0.06)',
            }}
          >
            <div className="flexbox-grow flexbox flexbox-align-center">
              {children}
            </div>
          </div>
          {/* Under the card */}
          {extraControl && (
            <div className="flexbox flexbox-centered margin-top-large">
              {extraControl}
            </div>
          )}

          {outerControl && (
            <div
              style={{ zIndex: 1 }}
              className="position-relative margin-top-large"
            >
              {outerControl}
            </div>
          )}
        </div>
        <div className="content-footer flexbox flexbox-align-end flexbox-justify-center margin-bottom-larger shade-20">
          <span>{`© ${new Date().getFullYear()} Slite, Inc.`}</span>
          <a
            className="padding-left-normal font-weight-medium shade-20 primary-on-hover"
            rel="noopener noreferrer"
            target="_blank"
            href="https://slite.com/terms"
          >
            Terms
          </a>
          <a
            className="padding-left-normal font-weight-medium shade-20 primary-on-hover"
            rel="noopener noreferrer"
            target="_blank"
            href="https://slite.com/privacy"
          >
            Privacy
          </a>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    error:
      state.auth.error ||
      state.auth.renewalError ||
      getErrorFromLocation(window.location),
  }
}

export default connect(mapStateToProps)(AuthView)
